import type { ISearchPayload } from '@gp/types/global';
import type { IPipelineChangeDetailFetchParams } from '@gp/types/changeLog';

/**
 * 判断是否为To Be Confirm
 * @param tbc tbc值
 * @returns 是否为To Be Confirm
 */
export const getIsTBC = (tbc?: number | string | null): boolean => {
  return tbc === '2' || tbc === 2;
};

/**
 * 获取当前Milestone数据 是否为 TBC, 1 代表 未确认，2 代表 已确认(TBC)
 * @param data Milestone数据对象
 * @param milestoneField milestone的取值字段
 * @returns 当前Milestone数据 是否为 TBC
 */
// export const getIsMilestoneTBC = (data: Record<string, any>, milestoneField = 'next_checkpoint'): boolean => {
//   const milestones = data?.milestones;
//   const milestone = data?.[milestoneField];
//   if (!Array.isArray(milestones) || !milestones.length || !milestone) return false;
//   const milestoneObj = milestones.find((item) => item?.milestone === milestone);
//   return getIsTBC(milestoneObj?.date_confirm);
// };

export const formatSearchParams = (
  searchPayload?: ISearchPayload,
): Pick<
  IPipelineChangeDetailFetchParams,
  'search_type' | 'search' | 'project_ids' | 'search_id'
> => {
  const { search_type: searchType, search, search_ids: searchIds } = searchPayload || {};
  return {
    // 搜索
    search_type: searchType || 'exact',
    // 搜索
    search: search?.[0] || '',
    //   搜索id
    search_id: searchIds || [],
    // project_ids: searchIds || [],
  };
};

export const getActionItemCategoryOptions = (actionItemCategory: any) => {
  if (Array.isArray(actionItemCategory) && actionItemCategory?.length > 0) {
    return actionItemCategory?.map((item) => {
      return {
        text: item,
        value: item,
      };
    });
  }
  return [];
};
